// extracted by mini-css-extract-plugin
export default {"tooltip":"Vp-z","sharingV2":"Wp-z","sharingIconsV2":"Xp-z","links":"Yp-z","link":"Zp-z","facebookV2":"_p-z","twitterV2":"aq-z","pinterestV2":"bq-z"};